let language = {
    "LBL_HOME":"Home",
    "LBL_DEFAULT_SEARCH":"Search",
    "LBL_DEFAULT_ADMIN":"Admin",
    "LBL_NEW_REPORT_AUTHS":"New Report Authorization",
    "LBL_VIEW_REPORT_AUTHS":"View Report Authorization",
    "LBL_USER_TYPE":"User Type",
    "LBL_REPORT_GROUP":"Report Group",
    "LBL_REPORT_NAME":"Report Name",
    "LBL_REPORT_AUTHS":"Report Authorization",
    "LBL_DEFAULT_REPORT":"Report",
    "":"setting",
    "":"setting",
    "":"setting",
    "":"setting",
    "":"setting",
    "":"setting",
    "":"setting",
    
}

export default language;